/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as KonsollRouteImport } from './routes/konsoll'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MineKjopRouteImport } from './routes/mine-kjop'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as ResultatRouteImport } from './routes/resultat'
import { Route as YearResultsRouteImport } from './routes/year-results'
import { Route as AppAccountRouteImport } from './routes/_app/account'
import { Route as AppCalculatorRouteImport } from './routes/_app/calculator'
import { Route as AppMineStederRouteImport } from './routes/_app/mine-steder'
import { Route as AppYearRouteImport } from './routes/_app/year'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminAbonnementerRouteImport } from './routes/admin/abonnementer'
import { Route as AdminBrukereRouteImport } from './routes/admin/brukere'
import { Route as CheckoutCancelRouteImport } from './routes/checkout/cancel'
import { Route as CheckoutSuccessRouteImport } from './routes/checkout/success'
import { Route as KonsollIndexRouteImport } from './routes/konsoll/index'
import { Route as KonsollAbonnementRouteImport } from './routes/konsoll/abonnement'
import { Route as KonsollApiRouteImport } from './routes/konsoll/api'
import { Route as KonsollForbrukRouteImport } from './routes/konsoll/forbruk'
import { Route as AppAccountIndexRouteImport } from './routes/_app/account/index'
import { Route as AppAccountAbonnementRouteImport } from './routes/_app/account/abonnement'
import { Route as AppAccountProfilRouteImport } from './routes/_app/account/profil'
import { Route as AppAccountSikkerhetRouteImport } from './routes/_app/account/sikkerhet'
import { Route as AppAccountStederRouteImport } from './routes/_app/account/steder'
import { Route as AppAccountAdminIndexRouteImport } from './routes/_app/account/admin/index'
import { Route as AppAccountAdminAbonnementerRouteImport } from './routes/_app/account/admin/abonnementer'
import { Route as AppAccountAdminBrukereRouteImport } from './routes/_app/account/admin/brukere'
import { Route as AppAccountAdminInnstillingerRouteImport } from './routes/_app/account/admin/innstillinger'
import { Route as AppAccountKonsollIndexRouteImport } from './routes/_app/account/konsoll/index'
import { Route as AppAccountKonsollApiRouteImport } from './routes/_app/account/konsoll/api'
import { Route as AppAccountKonsollForbrukRouteImport } from './routes/_app/account/konsoll/forbruk'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const KonsollRoute = KonsollRouteImport.update({
  id: '/konsoll',
  path: '/konsoll',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const MineKjopRoute = MineKjopRouteImport.update({
  id: '/mine-kjop',
  path: '/mine-kjop',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const ResultatRoute = ResultatRouteImport.update({
  id: '/resultat',
  path: '/resultat',
  getParentRoute: () => rootRouteImport,
} as any)
const YearResultsRoute = YearResultsRouteImport.update({
  id: '/year-results',
  path: '/year-results',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)
const AppCalculatorRoute = AppCalculatorRouteImport.update({
  id: '/calculator',
  path: '/calculator',
  getParentRoute: () => AppRoute,
} as any)
const AppMineStederRoute = AppMineStederRouteImport.update({
  id: '/mine-steder',
  path: '/mine-steder',
  getParentRoute: () => AppRoute,
} as any)
const AppYearRoute = AppYearRouteImport.update({
  id: '/year',
  path: '/year',
  getParentRoute: () => AppRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAbonnementerRoute = AdminAbonnementerRouteImport.update({
  id: '/abonnementer',
  path: '/abonnementer',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBrukereRoute = AdminBrukereRouteImport.update({
  id: '/brukere',
  path: '/brukere',
  getParentRoute: () => AdminRoute,
} as any)
const CheckoutCancelRoute = CheckoutCancelRouteImport.update({
  id: '/checkout/cancel',
  path: '/checkout/cancel',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutSuccessRoute = CheckoutSuccessRouteImport.update({
  id: '/checkout/success',
  path: '/checkout/success',
  getParentRoute: () => rootRouteImport,
} as any)
const KonsollIndexRoute = KonsollIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => KonsollRoute,
} as any)
const KonsollAbonnementRoute = KonsollAbonnementRouteImport.update({
  id: '/abonnement',
  path: '/abonnement',
  getParentRoute: () => KonsollRoute,
} as any)
const KonsollApiRoute = KonsollApiRouteImport.update({
  id: '/api',
  path: '/api',
  getParentRoute: () => KonsollRoute,
} as any)
const KonsollForbrukRoute = KonsollForbrukRouteImport.update({
  id: '/forbruk',
  path: '/forbruk',
  getParentRoute: () => KonsollRoute,
} as any)
const AppAccountIndexRoute = AppAccountIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAccountRoute,
} as any)
const AppAccountAbonnementRoute = AppAccountAbonnementRouteImport.update({
  id: '/abonnement',
  path: '/abonnement',
  getParentRoute: () => AppAccountRoute,
} as any)
const AppAccountProfilRoute = AppAccountProfilRouteImport.update({
  id: '/profil',
  path: '/profil',
  getParentRoute: () => AppAccountRoute,
} as any)
const AppAccountSikkerhetRoute = AppAccountSikkerhetRouteImport.update({
  id: '/sikkerhet',
  path: '/sikkerhet',
  getParentRoute: () => AppAccountRoute,
} as any)
const AppAccountStederRoute = AppAccountStederRouteImport.update({
  id: '/steder',
  path: '/steder',
  getParentRoute: () => AppAccountRoute,
} as any)
const AppAccountAdminIndexRoute = AppAccountAdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => AppAccountRoute,
} as any)
const AppAccountAdminAbonnementerRoute =
  AppAccountAdminAbonnementerRouteImport.update({
    id: '/admin/abonnementer',
    path: '/admin/abonnementer',
    getParentRoute: () => AppAccountRoute,
  } as any)
const AppAccountAdminBrukereRoute = AppAccountAdminBrukereRouteImport.update({
  id: '/admin/brukere',
  path: '/admin/brukere',
  getParentRoute: () => AppAccountRoute,
} as any)
const AppAccountAdminInnstillingerRoute =
  AppAccountAdminInnstillingerRouteImport.update({
    id: '/admin/innstillinger',
    path: '/admin/innstillinger',
    getParentRoute: () => AppAccountRoute,
  } as any)
const AppAccountKonsollIndexRoute = AppAccountKonsollIndexRouteImport.update({
  id: '/konsoll/',
  path: '/konsoll/',
  getParentRoute: () => AppAccountRoute,
} as any)
const AppAccountKonsollApiRoute = AppAccountKonsollApiRouteImport.update({
  id: '/konsoll/api',
  path: '/konsoll/api',
  getParentRoute: () => AppAccountRoute,
} as any)
const AppAccountKonsollForbrukRoute =
  AppAccountKonsollForbrukRouteImport.update({
    id: '/konsoll/forbruk',
    path: '/konsoll/forbruk',
    getParentRoute: () => AppAccountRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/konsoll': typeof KonsollRouteWithChildren
  '/login': typeof LoginRoute
  '/mine-kjop': typeof MineKjopRoute
  '/pricing': typeof PricingRoute
  '/resultat': typeof ResultatRoute
  '/year-results': typeof YearResultsRoute
  '/account': typeof AppAccountRouteWithChildren
  '/calculator': typeof AppCalculatorRoute
  '/mine-steder': typeof AppMineStederRoute
  '/year': typeof AppYearRoute
  '/admin/abonnementer': typeof AdminAbonnementerRoute
  '/admin/brukere': typeof AdminBrukereRoute
  '/checkout/cancel': typeof CheckoutCancelRoute
  '/checkout/success': typeof CheckoutSuccessRoute
  '/konsoll/abonnement': typeof KonsollAbonnementRoute
  '/konsoll/api': typeof KonsollApiRoute
  '/konsoll/forbruk': typeof KonsollForbrukRoute
  '/admin/': typeof AdminIndexRoute
  '/konsoll/': typeof KonsollIndexRoute
  '/account/abonnement': typeof AppAccountAbonnementRoute
  '/account/profil': typeof AppAccountProfilRoute
  '/account/sikkerhet': typeof AppAccountSikkerhetRoute
  '/account/steder': typeof AppAccountStederRoute
  '/account/': typeof AppAccountIndexRoute
  '/account/admin/abonnementer': typeof AppAccountAdminAbonnementerRoute
  '/account/admin/brukere': typeof AppAccountAdminBrukereRoute
  '/account/admin/innstillinger': typeof AppAccountAdminInnstillingerRoute
  '/account/konsoll/api': typeof AppAccountKonsollApiRoute
  '/account/konsoll/forbruk': typeof AppAccountKonsollForbrukRoute
  '/account/admin/': typeof AppAccountAdminIndexRoute
  '/account/konsoll/': typeof AppAccountKonsollIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/mine-kjop': typeof MineKjopRoute
  '/pricing': typeof PricingRoute
  '/resultat': typeof ResultatRoute
  '/year-results': typeof YearResultsRoute
  '/calculator': typeof AppCalculatorRoute
  '/mine-steder': typeof AppMineStederRoute
  '/year': typeof AppYearRoute
  '/admin/abonnementer': typeof AdminAbonnementerRoute
  '/admin/brukere': typeof AdminBrukereRoute
  '/checkout/cancel': typeof CheckoutCancelRoute
  '/checkout/success': typeof CheckoutSuccessRoute
  '/konsoll/abonnement': typeof KonsollAbonnementRoute
  '/konsoll/api': typeof KonsollApiRoute
  '/konsoll/forbruk': typeof KonsollForbrukRoute
  '/admin': typeof AdminIndexRoute
  '/konsoll': typeof KonsollIndexRoute
  '/account/abonnement': typeof AppAccountAbonnementRoute
  '/account/profil': typeof AppAccountProfilRoute
  '/account/sikkerhet': typeof AppAccountSikkerhetRoute
  '/account/steder': typeof AppAccountStederRoute
  '/account': typeof AppAccountIndexRoute
  '/account/admin/abonnementer': typeof AppAccountAdminAbonnementerRoute
  '/account/admin/brukere': typeof AppAccountAdminBrukereRoute
  '/account/admin/innstillinger': typeof AppAccountAdminInnstillingerRoute
  '/account/konsoll/api': typeof AppAccountKonsollApiRoute
  '/account/konsoll/forbruk': typeof AppAccountKonsollForbrukRoute
  '/account/admin': typeof AppAccountAdminIndexRoute
  '/account/konsoll': typeof AppAccountKonsollIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/konsoll': typeof KonsollRouteWithChildren
  '/login': typeof LoginRoute
  '/mine-kjop': typeof MineKjopRoute
  '/pricing': typeof PricingRoute
  '/resultat': typeof ResultatRoute
  '/year-results': typeof YearResultsRoute
  '/_app/account': typeof AppAccountRouteWithChildren
  '/_app/calculator': typeof AppCalculatorRoute
  '/_app/mine-steder': typeof AppMineStederRoute
  '/_app/year': typeof AppYearRoute
  '/admin/abonnementer': typeof AdminAbonnementerRoute
  '/admin/brukere': typeof AdminBrukereRoute
  '/checkout/cancel': typeof CheckoutCancelRoute
  '/checkout/success': typeof CheckoutSuccessRoute
  '/konsoll/abonnement': typeof KonsollAbonnementRoute
  '/konsoll/api': typeof KonsollApiRoute
  '/konsoll/forbruk': typeof KonsollForbrukRoute
  '/admin/': typeof AdminIndexRoute
  '/konsoll/': typeof KonsollIndexRoute
  '/_app/account/abonnement': typeof AppAccountAbonnementRoute
  '/_app/account/profil': typeof AppAccountProfilRoute
  '/_app/account/sikkerhet': typeof AppAccountSikkerhetRoute
  '/_app/account/steder': typeof AppAccountStederRoute
  '/_app/account/': typeof AppAccountIndexRoute
  '/_app/account/admin/abonnementer': typeof AppAccountAdminAbonnementerRoute
  '/_app/account/admin/brukere': typeof AppAccountAdminBrukereRoute
  '/_app/account/admin/innstillinger': typeof AppAccountAdminInnstillingerRoute
  '/_app/account/konsoll/api': typeof AppAccountKonsollApiRoute
  '/_app/account/konsoll/forbruk': typeof AppAccountKonsollForbrukRoute
  '/_app/account/admin/': typeof AppAccountAdminIndexRoute
  '/_app/account/konsoll/': typeof AppAccountKonsollIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/konsoll'
    | '/login'
    | '/mine-kjop'
    | '/pricing'
    | '/resultat'
    | '/year-results'
    | '/account'
    | '/calculator'
    | '/mine-steder'
    | '/year'
    | '/admin/abonnementer'
    | '/admin/brukere'
    | '/checkout/cancel'
    | '/checkout/success'
    | '/konsoll/abonnement'
    | '/konsoll/api'
    | '/konsoll/forbruk'
    | '/admin/'
    | '/konsoll/'
    | '/account/abonnement'
    | '/account/profil'
    | '/account/sikkerhet'
    | '/account/steder'
    | '/account/'
    | '/account/admin/abonnementer'
    | '/account/admin/brukere'
    | '/account/admin/innstillinger'
    | '/account/konsoll/api'
    | '/account/konsoll/forbruk'
    | '/account/admin/'
    | '/account/konsoll/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/mine-kjop'
    | '/pricing'
    | '/resultat'
    | '/year-results'
    | '/calculator'
    | '/mine-steder'
    | '/year'
    | '/admin/abonnementer'
    | '/admin/brukere'
    | '/checkout/cancel'
    | '/checkout/success'
    | '/konsoll/abonnement'
    | '/konsoll/api'
    | '/konsoll/forbruk'
    | '/admin'
    | '/konsoll'
    | '/account/abonnement'
    | '/account/profil'
    | '/account/sikkerhet'
    | '/account/steder'
    | '/account'
    | '/account/admin/abonnementer'
    | '/account/admin/brukere'
    | '/account/admin/innstillinger'
    | '/account/konsoll/api'
    | '/account/konsoll/forbruk'
    | '/account/admin'
    | '/account/konsoll'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/admin'
    | '/konsoll'
    | '/login'
    | '/mine-kjop'
    | '/pricing'
    | '/resultat'
    | '/year-results'
    | '/_app/account'
    | '/_app/calculator'
    | '/_app/mine-steder'
    | '/_app/year'
    | '/admin/abonnementer'
    | '/admin/brukere'
    | '/checkout/cancel'
    | '/checkout/success'
    | '/konsoll/abonnement'
    | '/konsoll/api'
    | '/konsoll/forbruk'
    | '/admin/'
    | '/konsoll/'
    | '/_app/account/abonnement'
    | '/_app/account/profil'
    | '/_app/account/sikkerhet'
    | '/_app/account/steder'
    | '/_app/account/'
    | '/_app/account/admin/abonnementer'
    | '/_app/account/admin/brukere'
    | '/_app/account/admin/innstillinger'
    | '/_app/account/konsoll/api'
    | '/_app/account/konsoll/forbruk'
    | '/_app/account/admin/'
    | '/_app/account/konsoll/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AdminRoute: typeof AdminRouteWithChildren
  KonsollRoute: typeof KonsollRouteWithChildren
  LoginRoute: typeof LoginRoute
  MineKjopRoute: typeof MineKjopRoute
  PricingRoute: typeof PricingRoute
  ResultatRoute: typeof ResultatRoute
  YearResultsRoute: typeof YearResultsRoute
  CheckoutCancelRoute: typeof CheckoutCancelRoute
  CheckoutSuccessRoute: typeof CheckoutSuccessRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/konsoll': {
      id: '/konsoll'
      path: '/konsoll'
      fullPath: '/konsoll'
      preLoaderRoute: typeof KonsollRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mine-kjop': {
      id: '/mine-kjop'
      path: '/mine-kjop'
      fullPath: '/mine-kjop'
      preLoaderRoute: typeof MineKjopRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resultat': {
      id: '/resultat'
      path: '/resultat'
      fullPath: '/resultat'
      preLoaderRoute: typeof ResultatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/year-results': {
      id: '/year-results'
      path: '/year-results'
      fullPath: '/year-results'
      preLoaderRoute: typeof YearResultsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/calculator': {
      id: '/_app/calculator'
      path: '/calculator'
      fullPath: '/calculator'
      preLoaderRoute: typeof AppCalculatorRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/mine-steder': {
      id: '/_app/mine-steder'
      path: '/mine-steder'
      fullPath: '/mine-steder'
      preLoaderRoute: typeof AppMineStederRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/year': {
      id: '/_app/year'
      path: '/year'
      fullPath: '/year'
      preLoaderRoute: typeof AppYearRouteImport
      parentRoute: typeof AppRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/abonnementer': {
      id: '/admin/abonnementer'
      path: '/abonnementer'
      fullPath: '/admin/abonnementer'
      preLoaderRoute: typeof AdminAbonnementerRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/brukere': {
      id: '/admin/brukere'
      path: '/brukere'
      fullPath: '/admin/brukere'
      preLoaderRoute: typeof AdminBrukereRouteImport
      parentRoute: typeof AdminRoute
    }
    '/checkout/cancel': {
      id: '/checkout/cancel'
      path: '/checkout/cancel'
      fullPath: '/checkout/cancel'
      preLoaderRoute: typeof CheckoutCancelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout/success': {
      id: '/checkout/success'
      path: '/checkout/success'
      fullPath: '/checkout/success'
      preLoaderRoute: typeof CheckoutSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/konsoll/': {
      id: '/konsoll/'
      path: '/'
      fullPath: '/konsoll/'
      preLoaderRoute: typeof KonsollIndexRouteImport
      parentRoute: typeof KonsollRoute
    }
    '/konsoll/abonnement': {
      id: '/konsoll/abonnement'
      path: '/abonnement'
      fullPath: '/konsoll/abonnement'
      preLoaderRoute: typeof KonsollAbonnementRouteImport
      parentRoute: typeof KonsollRoute
    }
    '/konsoll/api': {
      id: '/konsoll/api'
      path: '/api'
      fullPath: '/konsoll/api'
      preLoaderRoute: typeof KonsollApiRouteImport
      parentRoute: typeof KonsollRoute
    }
    '/konsoll/forbruk': {
      id: '/konsoll/forbruk'
      path: '/forbruk'
      fullPath: '/konsoll/forbruk'
      preLoaderRoute: typeof KonsollForbrukRouteImport
      parentRoute: typeof KonsollRoute
    }
    '/_app/account/': {
      id: '/_app/account/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof AppAccountIndexRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/_app/account/abonnement': {
      id: '/_app/account/abonnement'
      path: '/abonnement'
      fullPath: '/account/abonnement'
      preLoaderRoute: typeof AppAccountAbonnementRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/_app/account/profil': {
      id: '/_app/account/profil'
      path: '/profil'
      fullPath: '/account/profil'
      preLoaderRoute: typeof AppAccountProfilRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/_app/account/sikkerhet': {
      id: '/_app/account/sikkerhet'
      path: '/sikkerhet'
      fullPath: '/account/sikkerhet'
      preLoaderRoute: typeof AppAccountSikkerhetRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/_app/account/steder': {
      id: '/_app/account/steder'
      path: '/steder'
      fullPath: '/account/steder'
      preLoaderRoute: typeof AppAccountStederRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/_app/account/admin/': {
      id: '/_app/account/admin/'
      path: '/admin'
      fullPath: '/account/admin/'
      preLoaderRoute: typeof AppAccountAdminIndexRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/_app/account/admin/abonnementer': {
      id: '/_app/account/admin/abonnementer'
      path: '/admin/abonnementer'
      fullPath: '/account/admin/abonnementer'
      preLoaderRoute: typeof AppAccountAdminAbonnementerRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/_app/account/admin/brukere': {
      id: '/_app/account/admin/brukere'
      path: '/admin/brukere'
      fullPath: '/account/admin/brukere'
      preLoaderRoute: typeof AppAccountAdminBrukereRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/_app/account/admin/innstillinger': {
      id: '/_app/account/admin/innstillinger'
      path: '/admin/innstillinger'
      fullPath: '/account/admin/innstillinger'
      preLoaderRoute: typeof AppAccountAdminInnstillingerRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/_app/account/konsoll/': {
      id: '/_app/account/konsoll/'
      path: '/konsoll'
      fullPath: '/account/konsoll/'
      preLoaderRoute: typeof AppAccountKonsollIndexRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/_app/account/konsoll/api': {
      id: '/_app/account/konsoll/api'
      path: '/konsoll/api'
      fullPath: '/account/konsoll/api'
      preLoaderRoute: typeof AppAccountKonsollApiRouteImport
      parentRoute: typeof AppAccountRoute
    }
    '/_app/account/konsoll/forbruk': {
      id: '/_app/account/konsoll/forbruk'
      path: '/konsoll/forbruk'
      fullPath: '/account/konsoll/forbruk'
      preLoaderRoute: typeof AppAccountKonsollForbrukRouteImport
      parentRoute: typeof AppAccountRoute
    }
  }
}

interface AppAccountRouteChildren {
  AppAccountAbonnementRoute: typeof AppAccountAbonnementRoute
  AppAccountProfilRoute: typeof AppAccountProfilRoute
  AppAccountSikkerhetRoute: typeof AppAccountSikkerhetRoute
  AppAccountStederRoute: typeof AppAccountStederRoute
  AppAccountIndexRoute: typeof AppAccountIndexRoute
  AppAccountAdminAbonnementerRoute: typeof AppAccountAdminAbonnementerRoute
  AppAccountAdminBrukereRoute: typeof AppAccountAdminBrukereRoute
  AppAccountAdminInnstillingerRoute: typeof AppAccountAdminInnstillingerRoute
  AppAccountKonsollApiRoute: typeof AppAccountKonsollApiRoute
  AppAccountKonsollForbrukRoute: typeof AppAccountKonsollForbrukRoute
  AppAccountAdminIndexRoute: typeof AppAccountAdminIndexRoute
  AppAccountKonsollIndexRoute: typeof AppAccountKonsollIndexRoute
}

const AppAccountRouteChildren: AppAccountRouteChildren = {
  AppAccountAbonnementRoute: AppAccountAbonnementRoute,
  AppAccountProfilRoute: AppAccountProfilRoute,
  AppAccountSikkerhetRoute: AppAccountSikkerhetRoute,
  AppAccountStederRoute: AppAccountStederRoute,
  AppAccountIndexRoute: AppAccountIndexRoute,
  AppAccountAdminAbonnementerRoute: AppAccountAdminAbonnementerRoute,
  AppAccountAdminBrukereRoute: AppAccountAdminBrukereRoute,
  AppAccountAdminInnstillingerRoute: AppAccountAdminInnstillingerRoute,
  AppAccountKonsollApiRoute: AppAccountKonsollApiRoute,
  AppAccountKonsollForbrukRoute: AppAccountKonsollForbrukRoute,
  AppAccountAdminIndexRoute: AppAccountAdminIndexRoute,
  AppAccountKonsollIndexRoute: AppAccountKonsollIndexRoute,
}

const AppAccountRouteWithChildren = AppAccountRoute._addFileChildren(
  AppAccountRouteChildren,
)

interface AppRouteChildren {
  AppAccountRoute: typeof AppAccountRouteWithChildren
  AppCalculatorRoute: typeof AppCalculatorRoute
  AppMineStederRoute: typeof AppMineStederRoute
  AppYearRoute: typeof AppYearRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountRoute: AppAccountRouteWithChildren,
  AppCalculatorRoute: AppCalculatorRoute,
  AppMineStederRoute: AppMineStederRoute,
  AppYearRoute: AppYearRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AdminRouteChildren {
  AdminAbonnementerRoute: typeof AdminAbonnementerRoute
  AdminBrukereRoute: typeof AdminBrukereRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAbonnementerRoute: AdminAbonnementerRoute,
  AdminBrukereRoute: AdminBrukereRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface KonsollRouteChildren {
  KonsollAbonnementRoute: typeof KonsollAbonnementRoute
  KonsollApiRoute: typeof KonsollApiRoute
  KonsollForbrukRoute: typeof KonsollForbrukRoute
  KonsollIndexRoute: typeof KonsollIndexRoute
}

const KonsollRouteChildren: KonsollRouteChildren = {
  KonsollAbonnementRoute: KonsollAbonnementRoute,
  KonsollApiRoute: KonsollApiRoute,
  KonsollForbrukRoute: KonsollForbrukRoute,
  KonsollIndexRoute: KonsollIndexRoute,
}

const KonsollRouteWithChildren =
  KonsollRoute._addFileChildren(KonsollRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AdminRoute: AdminRouteWithChildren,
  KonsollRoute: KonsollRouteWithChildren,
  LoginRoute: LoginRoute,
  MineKjopRoute: MineKjopRoute,
  PricingRoute: PricingRoute,
  ResultatRoute: ResultatRoute,
  YearResultsRoute: YearResultsRoute,
  CheckoutCancelRoute: CheckoutCancelRoute,
  CheckoutSuccessRoute: CheckoutSuccessRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
